module.exports = __webpack_public_path__ + "static/media/swipeinorout.a7575be4.mp3";